import { render, staticRenderFns } from "./WsParticipantsImport.vue?vue&type=template&id=5473f7b0"
import script from "./WsParticipantsImport.vue?vue&type=script&lang=js"
export * from "./WsParticipantsImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports